<h2 class="mb-2">404 - Nicht gefunden</h2>
<div *ngIf="errorRessource" class="mt-4 alert alert-danger">
  Die gewünschte Seite konnte leider nicht gefunden werden.<br />
  {{ errorRessource }}
</div>
